import { ICellRenderer, ICellRendererParams } from '@ag-grid-community/core';
import { AsyncPipe } from '@angular/common';
import { Component, ViewChild } from '@angular/core';

import {
  AgCellWrapperComponent,
  ICellWrapperParams,
} from '@shared/ag-components/ag-cell-wrapper/ag-cell-wrapper.component';

import { ForecastTableGridComponent } from '../../forecast-table-grid.component';
import {
  ForecastTableGridDataInterface,
  ForecastTableGridParentComponentContext,
} from '../../models/forecast-table-grid.model';
import { ForecastTableGridPeriodCustomCurveComponent } from '../forecast-table-grid-period-custom-curve/forecast-table-grid-period-custom-curve.component';
import { ForecastTableGridPeriodPatientComponent } from '../forecast-table-grid-period-patient/forecast-table-grid-period-patient.component';
import { ForecastTableGridPeriodSiteComponent } from '../forecast-table-grid-period-site/forecast-table-grid-period-site.component';
import { ForecastTableGridPeriodTimeComponent } from '../forecast-table-grid-period-time/forecast-table-grid-period-time.component';

@Component({
  imports: [
    ForecastTableGridPeriodSiteComponent,
    ForecastTableGridPeriodPatientComponent,
    ForecastTableGridPeriodTimeComponent,
    ForecastTableGridPeriodCustomCurveComponent,
    AsyncPipe,
  ],
  selector: 'aux-forecast-table-grid-period',
  templateUrl: './forecast-table-grid-period.component.html',
})
export class ForecastTableGridPeriodComponent
  extends AgCellWrapperComponent
  implements ICellRenderer
{
  componentParent!: ForecastTableGridComponent;
  context!: ForecastTableGridParentComponentContext;
  data!: ForecastTableGridDataInterface;
  disablePeriod = false;
  params!: ICellRendererParams;
  @ViewChild(ForecastTableGridPeriodPatientComponent)
  patientComponent!: ForecastTableGridPeriodPatientComponent;
  @ViewChild(ForecastTableGridPeriodSiteComponent)
  siteComponent!: ForecastTableGridPeriodSiteComponent;
  @ViewChild(ForecastTableGridPeriodTimeComponent)
  timeComponent!: ForecastTableGridPeriodTimeComponent;
  value!: string;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.context = this.params.context;
    this.componentParent = this.context.componentParent;

    if (!this.componentParent.userHasModifyPermissions) {
      this.disablePeriod = true;
    }

    this.data = this.params.data;
    this.value = this.params.value;
    this.autoTestAttribute = this.getAutoTestAttribute(params);
  }

  getAutoTestAttribute(params: ICellWrapperParams): string {
    const isTotalCell = params.node.rowPinned === 'bottom';

    const field = params.colDef?.field || '';
    const index = params.rowIndex;

    const fieldName = params.customLocator || field;

    return isTotalCell ? `${fieldName}_total` : `${fieldName}_${index}`;
  }

  refresh(): boolean {
    return false;
  }
}
